export const treeselect = {
  root: {
    background: "{form.field.background}",
    disabledBackground: "{form.field.disabled.background}",
    filledBackground: "{form.field.filled.background}",
    filledHoverBackground: "{form.field.filled.hover.background}",
    filledFocusBackground: "{form.field.filled.focus.background}",
    borderColor: "{form.field.border.color}",
    hoverBorderColor: "{form.field.hover.border.color}",
    focusBorderColor: "{form.field.focus.border.color}",
    invalidBorderColor: "{form.field.invalid.border.color}",
    color: "{form.field.color}",
    disabledColor: "{form.field.disabled.color}",
    placeholderColor: "{form.field.placeholder.color}",
    invalidPlaceholderColor: "{form.field.invalid.placeholder.color}",
    shadow: "{form.field.shadow}",
    paddingX: "{form.field.padding.x}",
    paddingY: "{form.field.padding.y}",
    borderRadius: "{form.field.border.radius}",
    focusRing: {
      width: "{form.field.focus.ring.width}",
      style: "{form.field.focus.ring.style}",
      color: "{form.field.focus.ring.color}",
      offset: "{form.field.focus.ring.offset}",
      shadow: "{form.field.focus.ring.shadow}",
    },
    transitionDuration: "{form.field.transition.duration}",
    sm: {
      fontSize: "{form.field.sm.font.size}",
      paddingX: "{form.field.sm.padding.x}",
      paddingY: "{form.field.sm.padding.y}",
    },
    lg: {
      fontSize: "{form.field.lg.font.size}",
      paddingX: "{form.field.lg.padding.x}",
      paddingY: "{form.field.lg.padding.y}",
    },
  },
  dropdown: {
    width: "{form.field.icon.size}",
    color: "{form.field.icon.color}",
  },
  overlay: {
    background: "{overlay.select.background}",
    borderColor: "{overlay.select.border.color}",
    borderRadius: "{overlay.select.border.radius}",
    color: "{overlay.select.color}",
    shadow: "{overlay.select.shadow}",
  },
  tree: {
    padding: "{list.padding}",
  },
  emptyMessage: {
    padding: "{list.option.padding}",
  },
  chip: {
    borderRadius: "{border.radius.sm}",
  },
  clearIcon: {
    color: "{form.field.icon.color}",
  },
  extend: {
    ui: {
      fontLeading: "{form.field.font.leading}",
      header: {
        padding: "{list.header.padding}",
      },
      headerIcon: {
        paddingRight: "20px",
      },
    },
  },
  css: ({ dt }: any): string => `
    .p-treeselect {
      line-height: ${dt("treeselect.ui.font.leading")};
    }

    .p-treeselect-label-empty:before {
      content: '-';
    }

    .p-treeselect-overlay .p-iconfield:has(.p-tree-filter-input) {
      padding: ${dt("treeselect.ui.header.padding")};
    }

    .p-treeselect-overlay .p-iconfield:has(.p-tree-filter-input) .p-inputicon:last-child {
      inset-inline-end: ${dt("treeselect.ui.header.icon.padding.right")};
    }

    .p-treeselect.break-lines .p-treeselect-label-container {
      overflow: visible;
    }

    .p-treeselect.break-lines .p-treeselect-label {
      flex-wrap: wrap;
      white-space: normal;
      height: auto;
    }
  `,
};
